import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'
import { cn } from '../../lib/utils'

const alertVariants = cva(
	'relative w-full rounded-(--radius-md) border px-4 py-3 text-sm grid has-[>svg]:grid-cols-[16px_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start',
	{
		variants: {
			variant: {
				default: 'bg-(--color-card) border-(--color-border) text-(--color-foreground)',
				info: 'bg-(--color-info-light) border-(--color-info) text-(--color-info-dark)',
				success: 'bg-(--color-success-light) border-(--color-success) text-(--color-success-dark)',
				warning: 'bg-(--color-warning-light) border-(--color-warning) text-(--color-warning-dark)',
				error: 'bg-(--color-destructive-light) border-(--color-destructive) text-(--color-destructive)',
				destructive: 'bg-(--color-destructive-light) border-(--color-destructive) text-(--color-destructive)',
			},
		},
		defaultVariants: {
			variant: 'default',
		},
	}
)

export interface AlertProps
	extends React.HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof alertVariants> {}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(
	({ className, variant, ...props }, ref) => (
		<div ref={ref} role="alert" data-slot="alert" className={cn(alertVariants({ variant }), className)} {...props} />
	)
)
Alert.displayName = 'Alert'

const AlertTitle = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div
			ref={ref}
			data-slot="alert-title"
			className={cn('col-start-2 font-[500] leading-5', className)}
			{...props}
		/>
	)
)
AlertTitle.displayName = 'AlertTitle'

const AlertDescription = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div
			ref={ref}
			data-slot="alert-description"
			className={cn('col-start-2 text-sm opacity-90', className)}
			{...props}
		/>
	)
)
AlertDescription.displayName = 'AlertDescription'

export { Alert, AlertTitle, AlertDescription, alertVariants }
